import { Component, forwardRef } from '@angular/core';
import { UserActionBaseComponent } from '../userAction-base.component';
import { StartAction } from '../../../../Model/Dto/StartAction';
import { TranslateService } from '@ngx-translate/core';
import { ModelService } from '../../../../Services/model.service';
import { CatalogService } from 'app/Services/CatalogManagement/catalog.service';
import { MacroService } from 'app/Services/CatalogManagement/macro.service';
import { JobService } from 'app/Services/job.service';
import { LoginService } from 'app/Services/login.service';

@Component({
    selector: 'app-useraction-assign-mime-by-supplier-pid',
    templateUrl: './useraction-assign-mime-by-supplier-pid.component.html',
    providers: [
        { provide: UserActionBaseComponent, useExisting: forwardRef(() => UseractionAssignMimeBySupplierPidComponent) }
    ],
    standalone: false
})
export class UseractionAssignMimeBySupplierPidComponent extends UserActionBaseComponent {

  useContains: boolean = false;
  delimiter: string = '';
  prefix: string = '';
  postfix: string = '';

  constructor(
    public loginService: LoginService,
    public macroService: MacroService,
    public jobService: JobService,
    public translate: TranslateService,
    public catalogService: CatalogService
  ) {
    super(loginService, macroService);
  }

  public createParameterStringAsJsonString(): string {
    return JSON.stringify({
      useContains: this.useContains,
      delimiter: this.delimiter,
      prefix: this.prefix,
      postfix: this.postfix
    });
  }
  public parseParameter(parameter: string) {    
    if(!parameter)
      return;
    try {
      const parsed = JSON.parse(parameter);
      this.useContains = parsed.useContains;
      this.delimiter = parsed.delimiter;
      this.prefix = parsed.prefix;
      this.postfix = parsed.postfix;
    } catch (error) {
      console.error('Invalid JSON string provided:', error);
    }
  }
}
